/**
 * Owner: Masa Bayu
 * File: token-css-map.ts
 * Date:Time: 2026-09-15 20:00
 * Description: App-layer CSS values for QXRead tokens (presentation ≠ @qx/ui authority).
 */

import { QXREAD_A11Y_BASELINE, QXREAD_FOUNDATION_CSS_VARS } from '@qx/qxread-core';

/** Concrete presentation map for the QXRead light marketplace skin. */
export const QXREAD_TOKEN_CSS_VALUES = Object.freeze({
  [QXREAD_FOUNDATION_CSS_VARS.textPrimary]: '#13201a',
  '--qx-color-text-secondary': '#3d5248',
  [QXREAD_FOUNDATION_CSS_VARS.bgCanvas]: '#f2f5f3',
  '--qx-color-bg-elevated': '#ffffff',
  '--qx-color-border-default': '#c5d0ca',
  [QXREAD_FOUNDATION_CSS_VARS.focusRing]: '#0f6b5c',
  '--qx-color-brand-primary': '#0f6b5c',
  '--qx-color-accent': '#e11d8f',
  '--qx-color-publication-paper': '#eef3ef',
  '--qx-color-publication-ink': '#13201a',
  '--qx-space-1': '4px',
  '--qx-space-2': '8px',
  '--qx-space-3': '12px',
  [QXREAD_FOUNDATION_CSS_VARS.spaceMd]: '16px',
  '--qx-space-6': '24px',
  '--qx-space-8': '32px',
  [QXREAD_FOUNDATION_CSS_VARS.touchMin]: `${String(QXREAD_A11Y_BASELINE.minTouchTargetPx)}px`,
  '--qx-motion-fast': '120ms',
  '--qx-motion-normal': '220ms',
  '--qx-font-display': "'Syne', ui-sans-serif, system-ui, sans-serif",
  '--qx-font-body': "'Figtree', ui-sans-serif, system-ui, sans-serif",
} as const);

export type QxreadCssVarName = keyof typeof QXREAD_TOKEN_CSS_VALUES;

/**
 * Apply design-token CSS variables to a target element (usually documentElement).
 */
export function applyQxreadDesignTokens(
  target: { style: { setProperty: (name: string, value: string) => void } },
  values: Readonly<Record<string, string>> = QXREAD_TOKEN_CSS_VALUES,
): void {
  for (const [name, value] of Object.entries(values)) {
    target.style.setProperty(name, value);
  }
}
